export default __webpack_public_path__ + "4931ed6426599330c6bd5778a65698ae.ogg";